<template>
  <v-dialog v-model="opened" width="1200" persistent>
    <v-card>
      <v-card-title>
        Zaufane adresy IP
      </v-card-title>
      <v-card-text>
        <v-btn @click="createNew" color="primary">Nowe IP</v-btn>
        <data-table :headers="headers" :items="items">
        <template v-slot:item.actions="{item}">
          <v-btn color="error" @click="deleteItem(item)">Usuń</v-btn>
        </template>
        </data-table>
      </v-card-text>
      <v-card-actions>
        <v-btn color="secondary" @click="opened=false">Zamknij</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="createDialog" width="800" persistent>
      <v-card>
        <v-card-title>
          Nowe ip
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field v-model="createVm.ip" label="IP"></v-text-field>
              <v-text-field v-model="createVm.description" label="Opis"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="saveCreate">Zapisz</v-btn>
          <v-btn color="secondary" @click="createDialog = false">Anuluj</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
export default {
  data(){
    return{
      companyId: null,
      items: [],
      opened: false,
      createDialog:false,
      createVm: {},
      headers:[
        {
          text:"Id",
          value:"id"
        },
        {
          text:"IP",
          value:"ip"
        },
        {
          text:"Opis",
          value:"description"
        },
        {
          text:"Opcje",
          value:"actions"
        }
      ]
    }
  },
  methods:{
    async open(companyId){
      this.companyId = companyId
      this.data = null
      this.opened = true;
      await this.getItems();
    },
    createNew(){
      this.createDialog = true;
    },
    async saveCreate(){
      const {data} = await this.$http.post("IpWhiteList/Create", {...this.createVm, companyId: this.companyId})
      this.items.push(data);
      this.createDialog = false;
    },
    async deleteItem(item){
      await this.$http.delete("IpWhiteList/Delete?id=" + item.id);
      await this.getItems();
    },
    async getItems(){
      const { data } = await this.$http.get("IpWhiteList/GetList?companyId=" + this.companyId)
      this.items = data;
    }
  }
}
</script>